<template lang="pug">
.form.form---block(:class="{'form---success': sendForm}")
  .form__block
    .form__fields
      .form__field
        .input-text.input-text---icon
          input.input-text__input(type="text" :placeholder="formFieldNamePlaceholder" v-model="fieldName")

          svg.input-text__icon
            use(xlink:href="#form-name")

      .form__field
        .input-text.input-text---icon
          input.input-text__input(type="tel" :placeholder="formFieldPhonePlaceholder" v-model="fieldPhone" v-maska="['(###) ###-##-##', '(###) ###-##-##']")

          svg.input-text__icon
            use(xlink:href="#form-phone")

      .form__field
        .input-textarea
          textarea.input-textarea__input(:placeholder="formFieldTextPlaceholder" v-model="fieldText")

    .form__file
      label.form-file
        input.form-file__input(
          type="file"
          name="files"
          ref="files"
          id="files"
          multiple
          style="display: none;"
          @change="onFileChange"
        )

        svg.form-file__icon
          use(xlink:href="#form-file")

        .form-file__text(v-html="fileResult")

    .form__bottom
      .form__consent
        label.consent
          input.consent__input(
            type="checkbox"
            value="consent"
            checked="checked"
            v-model="consent"
          )
          span.consent__button
          span.consent__label(v-html="formConsent")

      .form__button
        .button.button---1.button---width.button---big(@click="getSend()" :class="{'button---disabled': v$.$invalid}")
          .button__text(v-html="formButtonName")

  .form__success
    .form-success
      svg.form-success__icon
        use(xlink:href="#icon-check")

      .form-success__title(v-html="formSuccessTitle")

      .form-success__text(v-html="formSuccessText")

      .form-success__button
        .button.button---1.button---big(@click="sendForm = false")
          .button__text(v-html="formSuccessButtonName")

</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
import { mapActions } from 'vuex'
export default {
  name: 'AppFormBlock',

  setup () {
    return { v$: useVuelidate() }
  },

  props: [
    "formSettingTitle",
    "formSettingSubject",

    "formButtonName",

    "formFieldName",
    "formFieldNamePlaceholder",
    "formFieldPhone",
    "formFieldPhonePlaceholder",
    "formFieldText",
    "formFieldTextPlaceholder",

    "formFileText",

    "formFieldPage",

    "formConsent",

    "formSuccessTitle",
    "formSuccessText",
    "formSuccessButtonName",

    "formPageId",
    "formPagePagetitle"
  ],

  data () {
    return {
      fieldName: '',
      fieldPhone: '',
      fieldText: '',
      consent: [],
      files: '',
      fileResult: this.formFileText,
      sendForm: false,
      fieldError: false
    }
  },

  methods: {
    ...mapActions([
      'Send'
    ]),

    onFileChange () {
      this.files = this.$refs.files.files

      if (this.files.length === 1) {
        this.fileResult = 'Добавлен ' + this.files.length + ' файл'
      } else if ((this.files.length === 2) || (this.files.length === 3) || (this.files.length === 4)) {
        this.fileResult = 'Добавлено ' + this.files.length + ' файла'
      } else {
        this.fileResult = 'Добавлено ' + this.files.length + ' файлов'
      }
    },

    getSend () {
      if (this.v$.$invalid) {
        this.fieldError = true
      }

      if (!this.v$.$invalid) {
        this.sendForm = true

        this.Send({
          setting: {
            title: this.formSettingTitle,
            subject: this.formSettingSubject,
          },

          fields: [
            {
              title: this.formFieldName,
              value: this.fieldName
            },
            {
              title: this.formFieldPhone,
              value: this.fieldPhone
            },
            {
              title: this.formFieldText,
              value: this.fieldText
            },
            {
              title: this.formFieldPage,
              value: this.formPagePagetitle + ' (' + this.formPageId + ')'
            },
          ],
          files: this.files
        })

        this.fieldName = this.fieldPhone = this.fieldText = ''
        this.consent = []

        setTimeout(() => {
          this.sendForm = false
        }, 5000)
      }
    }
  },

  validations () {
    return {
      fieldName: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(40)
      },
      fieldPhone: {
        required,
        minLength: minLength(15),
        maxLength: maxLength(15)
      },
      consent: {
        required
      }
    }
  }
}
</script>
